function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import gettext from 'js-utils/gettext';
import uniqueId from 'lodash/uniqueId';
import { getFileFromDropEvent, getFileFromBrowseEvent } from './utils';
import { addWindowDragEvent, removeWindowDragEvent } from './windowDragEventUtils';
import { DRAG_END_EVENT, DRAG_START_EVENT } from './constants';
import Label from '../label/Label';
import { TYPE_LABEL } from '../label/constants';
/**
 * A stateless utility component that handles drag and drop events
 * @extends React.PureComponent
 * @example
 * // <UploaderDropzone
 * //     onDragEvent={stateChangeFunc}
 * //     onFileDrop={fileDropFunc}
 * // >
 * //     Drag files here!
 * // </UploaderDropzone>
 */

var UploaderDropzone =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(UploaderDropzone, _React$PureComponent);

  function UploaderDropzone(props) {
    var _this;

    _classCallCheck(this, UploaderDropzone);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UploaderDropzone).call(this, props));
    _this.state = {
      isFocus: false
    };
    return _this;
  }

  _createClass(UploaderDropzone, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this._boundWindowDragEvent = this._handleDragEvent.bind(this);
      addWindowDragEvent(this._boundWindowDragEvent);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeWindowDragEvent(this._boundWindowDragEvent);
    }
  }, {
    key: "_handleDragEvent",
    value: function _handleDragEvent(eventType, event) {
      var onDragEvent = this.props.onDragEvent;
      event.preventDefault();

      if (eventType) {
        onDragEvent(eventType);
      }
    }
  }, {
    key: "_handleDrop",
    value: function _handleDrop(event) {
      var _this$props = this.props,
          onFileDrop = _this$props.onFileDrop,
          onDragEvent = _this$props.onDragEvent;
      var file = getFileFromDropEvent(event);
      event.preventDefault();

      if (file) {
        onFileDrop(file);
      }

      onDragEvent(DRAG_END_EVENT);
    }
  }, {
    key: "_handleFileChanged",
    value: function _handleFileChanged(event) {
      var _this$props2 = this.props,
          onFileDrop = _this$props2.onFileDrop,
          onDragEvent = _this$props2.onDragEvent;
      var file = getFileFromBrowseEvent(event);

      if (file) {
        onFileDrop(file);
      }

      onDragEvent(DRAG_END_EVENT);
    }
  }, {
    key: "_getPageLabelId",
    value: function _getPageLabelId() {
      if (!this._labelInputId) {
        this._labelInputId = uniqueId('uploader-dropzone-');
      }

      return this._labelInputId;
    }
  }, {
    key: "_handleOnFocus",
    value: function _handleOnFocus() {
      this.setState({
        isFocus: true
      });
    }
  }, {
    key: "_handleOnBlur",
    value: function _handleOnBlur() {
      this.setState({
        isFocus: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;

      var labelId = this._getPageLabelId();

      var dropzoneClassName = classNames({
        'eds-uploader-dropzone--is-focus': this.state.isFocus
      }, 'eds-uploader-dropzone');
      return React.createElement("div", {
        className: dropzoneClassName,
        onDragOver: this._handleDragEvent.bind(this, null),
        onDragEnter: this._handleDragEvent.bind(this, DRAG_START_EVENT),
        onDragLeave: this._handleDragEvent.bind(this, DRAG_END_EVENT),
        onDrop: this._handleDrop.bind(this),
        "data-spec": "uploader-dropzone"
      }, React.createElement("div", {
        className: "eds-uploader-dropzone__content",
        "data-spec": "dropzone-content"
      }, children), React.createElement(Label, {
        type: TYPE_LABEL,
        htmlFor: labelId
      }, React.createElement("span", {
        className: "eds-uploader-dropzone__cover",
        "data-spec": "dropzone-cover"
      }, React.createElement("span", {
        className: "eds-is-hidden-accessible"
      }, gettext('Choose a file'), React.createElement("input", {
        type: "file",
        className: "eds-uploader-dropzone__browse-input",
        "data-spec": "dropzone-browse-input",
        onChange: this._handleFileChanged.bind(this),
        onFocus: this._handleOnFocus.bind(this),
        onBlur: this._handleOnBlur.bind(this),
        id: labelId
      })))));
    }
  }]);

  return UploaderDropzone;
}(React.PureComponent);

_defineProperty(UploaderDropzone, "propTypes", {
  /**
   * Function that's invoked when a drag event occurs
   */
  onDragEvent: PropTypes.func.isRequired,

  /**
   * Function that's invoked when a file is dropped
   */
  onFileDrop: PropTypes.func.isRequired,

  /**
   * The dropzone content
   */
  children: PropTypes.node
});

export { UploaderDropzone as default };